<template>
    <div class="full-page auth" :class="{ 'nav-open': $sidebar.showSidebar }">
<!--        <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
            <div class="md-toolbar-row md-offset">
                <div class="md-toolbar-section-start">
                    <h3 class="md-title">{{ setRouteName }}</h3>
                </div>
            </div>
        </md-toolbar>-->
        <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
            <notifications/>
            <div class="page-header header-filter"
                :class="setPageClass"
            >
                <div class="flex w-full h-screen">
                    <div class="w-1/3 bg-white">
                        <div class="flex flex-col justify-between h-full">
                            <div class="container-logo h-3/4">
                                <img :src="logo" alt="logo" class="max-w-xs 2xl:max-w-md" />
                            </div>
                            <footer class="footer h-1/4">
                                <div class="container">
                                    <nav class="mx-auto">
                                        <div class="flex items-center justify-evenly">
                                            <p>GMD Sanitation</p>
                                            <p>85 rue Conrad Kilian 07500 Guilherand-Granges</p>
                                        </div>
                                        <div class="flex items-center justify-evenly">
                                            <md-button class="md-primary" href="tel:+33475404750" target="_blank">
                                                Tél. 04 75 40 47 50
                                            </md-button>
                                            <md-button class="md-primary" href="mailto:experts@gmd-sanitation.com">
                                                experts@gmd-sanitation.com
                                            </md-button>
                                        </div>
                                    </nav>
                                </div>
                            </footer>
                        </div>
                    </div>
                    <div class="w-2/3 filter-black bg-danger">
                        <div class="flex items-center h-full">
                            <div class="container">
                                <zoom-center-transition :duration="pageTransitionDuration"
                                                        mode="out-in">
                                    <router-view></router-view>
                                </zoom-center-transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import logo from '../../../assets/images/logo.png'
export default {
    props: {
        backgroundColor: {
            type: String,
            default: "black"
        }
    },
    inject: {
        autoClose: {
            default: true
        }
    },
    data() {
        return {
            responsive: false,
            showMenu: false,
            menuTransitionDuration: 250,
            pageTransitionDuration: 300,
            year: new Date().getFullYear(),
            logo: logo
        };
    },
    computed: {
        setPageClass() {
            return `${this.$route.name}-page`.toLowerCase();
        },
		setRouteName() {
        	let routeName = ''
        	switch(this.$route.name) {
        		case 'Login':
        			routeName = 'Connexion'
					break
				case 'Password Forgot':
					routeName = 'Mot de passe oublié'
					break
				case 'Password Reset':
					routeName = 'Réinitialiser son mot de passe'
					break
			}
			return routeName
		}
    },
    methods: {
        toggleSidebarPage() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },
        linkClick() {
            if (
                this.autoClose &&
                this.$sidebar &&
                this.$sidebar.showSidebar === true
            ) {
                this.$sidebar.displaySidebar(false);
            }
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        toggleNavbar() {
            document.body.classList.toggle("nav-open");
            this.showMenu = !this.showMenu;
        },
        closeMenu() {
            document.body.classList.remove("nav-open");
            this.showMenu = false;
        },
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
		goToLogin() {
			this.$router.push({name: 'Login'})
		},
		goToForgot() {
			this.$router.push({name: 'Password Forgot'})
		},
    },
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        this.closeMenu();
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    beforeRouteUpdate(to, from, next) {
        // Close the mobile menu first then transition to next page
        if (this.showMenu) {
            this.closeMenu();
            setTimeout(() => {
                next();
            }, this.menuTransitionDuration);
        } else {
            next();
        }
    }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;

footer {
    p {
        color: #3c4858;
        padding: 15px;
        font-weight: 500;
        border-radius: 3px;
        text-decoration: none;
        position: relative;
        display: block;
        font-size: 13px !important;
        text-transform: uppercase !important;
    }
}

@keyframes zoomIn8 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
        opacity: 1;
    }
}

.wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
}

@keyframes zoomOut8 {
    from {
        opacity: 1;
        transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
    }
    to {
        opacity: 0;
        transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
    }
}

.wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
}

.md-list-item-button {
	color: inherit !important;
	font-weight: 400;
	font-size: 12px;
	text-transform: uppercase;
	overflow: visible;
	border-radius: 3px;
	position: relative;
	display: block;
	padding: 0;
	text-decoration: none;

	svg {
		margin: 0 10px 0 0 !important;
		color: #FFFFFF !important;
		font-size: 16px !important;
		min-width: 16px !important;
	}
}

</style>
